<template>
  <div>
    <v-dialog v-model="dialog" max-width="470" persistent>
      <v-form @submit.prevent="onSetSchedule">
        <v-card>
          <v-card-title>
            Schedule Message
            <v-spacer> </v-spacer>
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              top
              color="#DCD8F3"
              content-class="arrow-down"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon @click="closeDialog()" v-on="on" v-bind="attrs"
                  >mdi-close</v-icon
                >
              </template>
              <span class="dark-purple-text font-weight-bold">Close</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col class="mr-3" cols="5">
                <v-menu
                  v-model="dateDropDown"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Select date"
                      append-icon="mdi-calendar-blank-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :min="
                      new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    :max="maxMonthLimit()"
                    @input="dateDropDown = false"
                    color="#67D1A0"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="ml-3" cols="5">
                <div id="time-filed">
                  <v-text-field
                    autofocus
                    class="temp"
                    v-model="time"
                    type="time"
                    label="Select time"
                    append-icon="mdi-clock-time-four-outline"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="my-2">
            <v-spacer></v-spacer>

            <v-btn text width="112" @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn
              tile
              width="112"
              elevation="0"
              type="submit"
              :loading="loader"
              class="white--text btn-success"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <div>
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      dateDropDown: false,
      date: "",
      time: "",
      moment: moment,
      loader: false,
    };
  },
  mixins: [snackbarMixin],
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  mounted() {
    eventBus.$on("sendScheduleMessage", (data) => {
      this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      let minutes;
      let hours;
      if (new Date().getMinutes() == 59) {
        minutes = "00";
        hours = new Date().getHours() + 1;
        this.time = hours + ":" + minutes;
      } else {
        hours = new Date().getHours();
        if (hours < 10) {
          hours = "0" + hours;
        }
        minutes = new Date().getMinutes() + 1;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        this.time = hours + ":" + minutes;
      }
      this.dialog = data;
      this.loader = false;
    });
  },
  methods: {
    /**
     * this function limits the date that a user can select to schadule a message.
     */
    maxMonthLimit() {
      //adding miliseconds of 30 days in current date
      let lastDateMili = new Date().getTime() + 2592000000;
      let lastDate = new Date(lastDateMili);
      // max limit of selecting date
      return (
        lastDate.getFullYear() +
        "-" +
        (lastDate.getMonth() + 1) +
        "-" +
        lastDate.getDate()
      );
    },
    onSetSchedule() {
      if (this.date > moment().format("YYYY-MM-DD")) {
        let dateTime = new Date(this.date + "T" + this.time);
        let c = dateTime.toUTCString();
        this.loader = true;
        eventBus.$emit("scheduleMessage", { scheduleTime: c });
      } else {
        let hours = this.time.split(":")[0];
        let mins = this.time.split(":")[1];
        let currentHours = new Date().getHours();
        let currentMins = new Date().getMinutes();
        if (currentHours < 10) {
          currentHours = "0"+currentHours;
        }
        if (currentMins < 10) {
          currentMins = "0"+currentMins;
        }
        if (hours == currentHours) {
          if (mins <= currentMins) {
            this.openSnackbar(true, "Invalid Time");
          } else {
            let dateTime = new Date(this.date + "T" + this.time);
            let c = dateTime.toUTCString();
            this.loader = true;
            eventBus.$emit("scheduleMessage", { scheduleTime: c });
          }
        } else if (hours > currentHours) {
          let dateTime = new Date(this.date + "T" + this.time);
          let c = dateTime.toUTCString();
          this.loader = true;
          eventBus.$emit("scheduleMessage", { scheduleTime: c });
        } else {
          this.openSnackbar(true, "Invalid Time");
        }
      }
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
